import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';
import { VatixError } from 'components/Error/types';
import { FilterType } from 'components/Grid/types';

import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

import { riskAssessmentTemplatesColumns } from './columns';

const NOT_ARCHIVED_FILTERS: FilterType[] = [{ field: 'status', operator: 'is not', value: '-false' }];

type RiskAssessmentTemplatesTableProps = {
  onError: (error: VatixError | null) => void;
};

const RiskAssessmentTemplatesTable: React.FunctionComponent<RiskAssessmentTemplatesTableProps> = ({
  onError,
}): React.ReactElement => {
  const { routing } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    if (!item.row.isActive) return;
    routing.push(reverse(routes.dashboard.risks.templates.details, { templateId: item.id as string }));
  };

  return (
    <Grid
      basicColumns={riskAssessmentTemplatesColumns}
      entity="template"
      filters={NOT_ARCHIVED_FILTERS}
      preferencesVersion={2}
      onError={onError}
      dataURL="/api/entities/riskAssessments/forms/"
      customNoRowsText="No risk assessment templates yet"
      filteredNoRowsText="No risk assessment templates match the current filters"
      onRowClick={onRowClick}
      onlyBasicExport
      sortBy={{ field: 'name', sort: 'asc' }}
    />
  );
};

export default RiskAssessmentTemplatesTable;
